import { Loader2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export const STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "closed", label: "Closed" },
];

const STATUS_STYLES = {
  new: "border-[color:var(--gold-500)] bg-[color:var(--gold-500)]/10 text-[color:var(--navy-950)]",
  contacted: "border-sky-600 bg-sky-50 text-sky-700",
  closed: "border-slate-400 bg-slate-100 text-slate-600",
};

/**
 * Per-lead status dropdown used in the AdminLeads table. Kept as its own
 * component to keep AdminLeads.jsx focused on data-fetching/orchestration.
 */
export const LeadStatusSelect = ({ leadId, status, saving, onChange }) => (
  <Select value={status} onValueChange={(val) => onChange(leadId, val)} disabled={saving}>
    <SelectTrigger
      className={cn("w-[130px] h-8 text-xs font-medium", STATUS_STYLES[status])}
      data-testid={`admin-lead-status-select-${leadId}`}
    >
      {saving ? (
        <span className="flex items-center gap-1.5"><Loader2 className="h-3 w-3 animate-spin" /> Saving...</span>
      ) : (
        <SelectValue />
      )}
    </SelectTrigger>
    <SelectContent className="bg-white">
      {STATUS_OPTIONS.map((opt) => (
        <SelectItem key={opt.value} value={opt.value} data-testid={`admin-lead-status-option-${opt.value}-${leadId}`}>
          {opt.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
